import { useLocation, useNavigate } from 'react-router-dom';
import { BackButton2 } from '../../../../common/BackButton2';
import { Fragment, useEffect, useState } from 'react';
import AccountSetupButton from '../../../../common/AccountSetupButton';
import { FiPlus } from 'react-icons/fi';
import { LuTrash } from 'react-icons/lu';
import ToastNotification from '../../../../common/ToastNotification';
import { createProductAPI } from '../../../../api/AccountSetup';
import { getCustomProductEffect, getProductCategoryEffect } from '../../../../hooks/Product';
import CostomTooltip from '../../../../common/CostomTooltip';
import { getSubscriptionDetail } from '../../../../common/CommonFunction';

export interface IForm {
  uuid: null;
  productName: string;
  price: string;
  desc: string;
  category: string;
  status?: string;
}

interface productProps {
  isSettings?: boolean | undefined;
}

const CreateProduct = (props: productProps) => {
  const { isSettings } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const companyUuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');
  const subscriptionPlanDetail = sessionStorage.getItem('planDetail');
  const shopId = sessionStorage.getItem('shopId');
  const { product, fetchData } = getCustomProductEffect(companyUuid ? companyUuid : '');
  const { categoryList } = getProductCategoryEffect();

  // Initialize the form with one empty row
  const [subscriptionData, setSubscriptionData] = useState<any>(null);
  const [form, setForm] = useState<IForm[]>([
    { uuid: null, productName: '', price: '', desc: '', category: '', status: 'create' }
  ]);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (subscriptionPlanDetail) {
      setSubscriptionData(JSON.parse(subscriptionPlanDetail));
    }
  }, []);

  const inputHandler = (value: string, type: string, index: number) => {
    const updatedForm = [...form];
    updatedForm[index] = {
      ...updatedForm[index],
      [type]:
        type === 'price'
          ? value === ''
            ? value
            : /^[0-9]*\.?[0-9]*$/.test(value)
              ? parseInt(value)
              : form[index].price
          : value
    };
    setForm(updatedForm);
  };

  const addNewRow = () => {
    if (
      // businessType !== 'Retail' &&
      subscriptionData &&
      subscriptionData?.data &&
      subscriptionData.data.cataloguesLimit
    ) {
      if (getProListLength(form) >= subscriptionData.data.cataloguesLimit) {
        return;
      } else {
        setForm([
          ...form,
          { uuid: null, productName: '', price: '', desc: '', category: '', status: 'create' }
        ]);
      }
    }
    // if (businessType === 'Retail') {
    //   setForm([...form, { uuid: null, productName: '', price: '', desc: '', category: '' }]);
    // }
  };

  const removeRow = (item: any, index: number) => {
    if (item.uuid) {
      const updatedForm = form.map((element, i) => {
        return {
          ...element,
          status:
            i === index
              ? 'delete'
              : element.status && ['delete', 'create'].includes(element.status)
                ? element.status
                : 'update'
        };
      });
      setForm(updatedForm);
    } else {
      const updatedForm = form.filter((_, i) => i !== index);
      setForm(updatedForm);
    }
  };

  const handleGoBack = () => {
    navigate('/account-setup/create-menu');
  };

  const isCheckFieldEmpty = (formInfo: any) => {
    return formInfo.some((item: any) => {
      return Object.keys(item)
        .filter((key) => key !== 'uuid')
        .some((key) => item[key] === '');
    });
  };

  const submithandler = async () => {
    if (!isCheckFieldEmpty(form)) {
      setDisable(true);
      const payload = {
        productList: form
      };
      const response = await createProductAPI(payload, companyUuid ? companyUuid : '');
      if (response.ok) {
        setDisable(false);
        const data = await response.json();
        ToastNotification({
          message: data.message
        });
        getSubscriptionDetail(businessType, shopId);
        if (!isSettings) {
          // setTimeout(() => {
          navigate('/account-setup/faq');
          // }, 1500);
        } else {
          fetchData();
        }
      } else {
        setDisable(false);
        const errorData = await response.json();
        ToastNotification({
          message: errorData.message,
          type: 'warning'
        });
      }
    } else {
      ToastNotification({
        message: 'Please fill all details',
        type: 'error'
      });
    }
  };

  useEffect(() => {
    if (product.length > 0) {
      setForm(
        product.map((data: any) => ({
          uuid: data.uuid,
          productName: data.productName,
          price: data.price,
          desc: data.desc,
          category: data.category,
          status: 'update'
        }))
      );
    }
  }, [JSON.stringify(product)]);

  const getProListLength = (list: any) =>
    list.filter((ele: any) => ele.status !== 'delete').length || 0;

  return (
    <div className="flex flex-col flex-1 bg-[#1E1E1E] rounded-lg lg:px-0 md:pt-3 lg:pt-6 p-2 overflow-y-auto">
      {!(location.pathname === '/settings/catalouge') && (
        <h2 className="lg:text-base md:text-base text-[14px] font-normal md:mb-[5px] mb-1 lg:ml-9 ml-[4px] md:ml-1">
          STEP 3
        </h2>
      )}

      <div className="flex ml-[4px] md:ml-1">
        {!(location.pathname === '/settings/catalouge') && (
          <div className="lg:mt-1 md:mt-2 mt-1 mr-1 sm:pt-[3px] lg:pt-0">
            <BackButton2 onClick={handleGoBack} />
          </div>
        )}
        <h1
          className={`h-[39px]  ${!(location.pathname === '/settings/catalouge') ? 'lg:ml-0' : 'lg:ml-5'} lg:mt-2 md:mt-[14px] mt-1 lg:mb-[4px] mb-[14px] text-[16px] sm:leading-[29.18px] md:text-base lg:text-base  font-medium`}
        >
          Food Offering Configuration
        </h1>
      </div>
      <table className="overflow-x-auto table-users text-white border-separate border-spacing-y-3 lg:px-8 ">
        <thead>
          <tr>
            <th className="pl-3 md:py-2 text-left md:text-sm sm:text-[8px] text-[8px]">
              Product Name
            </th>
            <th className="md:py-2 text-left md:text-sm sm:text-[8px] text-[8px]">Category</th>
            <th className="md:py-2 text-left md:text-sm sm:text-[8px] text-[8px]">Price</th>
            <th className="md:py-2 text-left md:text-sm sm:text-[8px] text-[8px] pr-1">
              Description
            </th>
            <th className="md:py-2 text-left md:text-sm sm:text-[8px] text-[8px] pr-1">Action</th>
          </tr>
        </thead>
        <tbody>
          {form.map((row, index) => (
            <Fragment key={index}>
              {row && row.status && row.status !== 'delete' && (
                <tr className="bg-[#343434]">
                  <td className="md:text-[16px] sm:text-[8px] rounded-tl-md rounded-bl-md">
                    <input
                      type="text"
                      value={row.productName}
                      onChange={(e) => inputHandler(e.target.value, 'productName', index)}
                      placeholder="Enter Product name"
                      className="block w-full lg:h-[48px] md:h-8 h-9 rounded-lg border-0 md:pt-5 pt-6 pb-5 pr-1 lg:pl-2 pl-1 shadow-sm bg-[#343434] placeholder:text-[#F3F3E099] placeholder:font-normal text-[8px] md:text-[12px] lg:text-sm sm:leading-[28px]"
                    />
                  </td>
                  <td className="md:text-[16px] sm:text-[8px] ">
                    <select
                      className="bg-[#343434] md:w-56 px-1 outline-none cursor-pointer text-[8px] md:text-[12px] lg:text-sm sm:leading-[28px]"
                      value={row.category}
                      onChange={(e) => inputHandler(e.target.value, 'category', index)}
                    >
                      <option value="" disabled selected>
                        Select a category
                      </option>
                      {categoryList.map((opt: any, ind: number) => (
                        <option key={ind}>{opt.categoryName}</option>
                      ))}
                    </select>
                  </td>
                  <td className="md:text-sm sm:text-[8px] ">
                    <input
                      type="text"
                      value={row.price}
                      onChange={(e) => inputHandler(e.target.value, 'price', index)}
                      placeholder="Enter Price"
                      className="block w-full lg:h-[48px] md:h-8 h-9 rounded-lg border-0 md:pt-5 pt-6 pb-5 pr-1 lg:pl-2 pl-1 shadow-sm bg-[#343434] placeholder:text-[#F3F3E099] placeholder:font-normal placeholder:text-[8px] md:placeholder:text-xs lg:placeholder:text-sm text-[8px] md:text-[12px] lg:text-sm sm:leading-[28px]"
                    />
                  </td>
                  <td className="md:text-sm sm:text-[8px] ">
                    <input
                      type="text"
                      value={row.desc}
                      onChange={(e) => inputHandler(e.target.value, 'desc', index)}
                      placeholder="Enter Description"
                      className="block w-full lg:h-[48px] md:h-8 h-9 rounded-lg border-0 md:pt-5 pt-6 pb-5 pr-1 lg:pl-2 pl-1 shadow-sm bg-[#343434] placeholder:text-[#F3F3E099] placeholder:font-normal placeholder:text-[8px] md:placeholder:text-xs lg:placeholder:text-sm text-[8px] md:text-[12px] lg:text-sm sm:leading-[28px]"
                    />
                  </td>
                  <td className="md:text-[16px] sm:text-[8px] rounded-tr-md rounded-br-md">
                    <div className="flex items-center">
                      <CostomTooltip
                        text={`You've reached the limit for adding catalogs.`}
                        position="left"
                        isDisabled={
                          // businessType !== 'Retail' &&
                          getProListLength(form) >= subscriptionData?.data?.cataloguesLimit
                        }
                      >
                        <FiPlus
                          className={`w-5 h-5 cursor-pointer 
                    ${getProListLength(form) >= subscriptionData?.data?.cataloguesLimit ? 'text-gray-400' : 'text-[#006BEA]'}`}
                          onClick={addNewRow}
                        />
                      </CostomTooltip>
                      {/* <FiPlus className="text-[#006BEA] w-5 h-5 cursor-pointer" onClick={addNewRow} /> */}
                      {index > 0 && (
                        <LuTrash
                          className="text-[#FF4C4C] md:w-4 md:h-4 w-4 h-4 mx-2 cursor-pointer"
                          onClick={() => removeRow(row, index)}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
      <div className="flex justify-end mt-auto lg:mb-2 lg:mr-8">
        <AccountSetupButton
          isFormValid={true}
          disable={false}
          btnText={`${location.pathname === '/settings/catalouge' ? 'Update' : 'Next'}`}
          textColor="#FFFFFF"
          backGroundColor="#006BEA"
          onClick={submithandler}
        />
      </div>
    </div>
  );
};

export default CreateProduct;
